import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

type SeasonFieldsProps = {
  season: "summer" | "winter";
  startMonth: number;
  startDay: number;
  endMonth: number;
  endDay: number;
  onChange: (field: "startMonth" | "startDay" | "endMonth" | "endDay", value: number) => void;
};

export function ThermostatPresetSeasonFields({ season, startMonth, startDay, endMonth, endDay, onChange }: SeasonFieldsProps) {
  const id = `preset-${season}`;
  return (
    <div className="mt-3 border-t border-gray-100 pt-3">
      <p className="mb-2 text-xs font-medium text-gray-600">Active dates</p>
      <div className="grid grid-cols-[1fr_auto_1fr] items-end gap-2">
        <div className="min-w-0">
          <Label htmlFor={`${id}-start-day`} className="text-[10px] text-gray-500">Start</Label>
          <div className="flex gap-1">
            <Select value={String(startMonth)} onValueChange={(v) => onChange("startMonth", Number(v))}>
              <SelectTrigger aria-label={`${season} start month`} className="h-8 min-w-0 flex-1 px-2" data-testid={`select-preset-${season}-start-month`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>{MONTHS.map((month, i) => <SelectItem key={month} value={String(i + 1)}>{month}</SelectItem>)}</SelectContent>
            </Select>
            <Input id={`${id}-start-day`} aria-label={`${season} start day`} type="number" min={1} max={31} className="h-8 w-14 px-2" value={startDay} onChange={(e) => onChange("startDay", Number(e.target.value) || 1)} />
          </div>
        </div>
        <span className="pb-2 text-xs text-gray-400">to</span>
        <div className="min-w-0">
          <Label htmlFor={`${id}-end-day`} className="text-[10px] text-gray-500">End</Label>
          <div className="flex gap-1">
            <Select value={String(endMonth)} onValueChange={(v) => onChange("endMonth", Number(v))}>
              <SelectTrigger aria-label={`${season} end month`} className="h-8 min-w-0 flex-1 px-2" data-testid={`select-preset-${season}-end-month`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>{MONTHS.map((month, i) => <SelectItem key={month} value={String(i + 1)}>{month}</SelectItem>)}</SelectContent>
            </Select>
            <Input id={`${id}-end-day`} aria-label={`${season} end day`} type="number" min={1} max={31} className="h-8 w-14 px-2" value={endDay} onChange={(e) => onChange("endDay", Number(e.target.value) || 1)} />
          </div>
        </div>
      </div>
    </div>
  );
}
